import Header from "./components/header.js";
import Main from "./components/main.js";
import Footer from "./components/footer.js";
import { useEffect } from "react";
import { inject } from "@vercel/analytics";

export default function App() {
  useEffect(() => {
    // Initialize inject for
    // audience analytics in vercel
    inject();

    // Get if user is using dark theme,
    // then set dark mood initially.
    const isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    if (isDark) {
      const htmTag = document.getElementsByTagName("html")[0];
      htmTag.className = "dark-theme";
    }
  }, []);

  return (
    <div id="app">
      <Header />
      <Main />
      <Footer />
    </div>
  );
}
